/*
*   @site           Preloaded: Site
*   @function       Module: Header
*   @author         Last17
*   @copyright      Copyright 2025, Preloaded.com
*   @version        0.01
*
*********************************************************************************************/


//-----------------------------------------------
// Imports
//-----------------------------------------------

//Template
import ModuleTemplate from '../_templates/ModuleTemplate';

//Libs
import Player from '@vimeo/player';

//-----------------------------------------------
// Class Definition
//-----------------------------------------------
export default class ModuleHero extends ModuleTemplate {

  //-----------------------------------------------
  // Init
  //-----------------------------------------------
  init() {
    //Calculate a type

    //Config
    this.config = {
      type: this.element.querySelector('.image__obj') ? 'image' : 'video',
      checkCount: 0,
      flags: {
        videoLoaded: false,
        videoPlaying: false
      }
    };

    //Elements
    if(this.config.type === 'video') {
      this.videoInit();
    }
  }

  //-----------------------------------------------
  // Video Init
  //-----------------------------------------------
  videoInit() {
    //Elements
    this.iframe = this.element.querySelector('iframe');
    this.videoWrapper = this.element.querySelector('.media-wrapper');

    //Init if found
    if(this.iframe) {
      //Create a player
      this.player = new Player(this.iframe);

      //Check the video time (allows us to catch a video for which we have missed the play event due to race conditions)
      this.videoTimeCheck();

      //On progress event
      /*this.player.on('progress', function(data) {
        console.log('Video Progress:', data);
      }.bind(this));*/
      
      //On pause event
      this.player.on('pause', function(data) {
        this.videoPause();
        console.log('Video Event: Pause');
      }.bind(this));

      //On play event
      this.player.on('play', function(data) {
        this.videoPlay();
        console.log('Video Event: Play');
      }.bind(this));
    }
  }

  //-----------------------------------------------
  // Video time check
  //-----------------------------------------------
  videoTimeCheck() {
    this.player.getCurrentTime().then((seconds) => {
      if(!this.config.flags.videoPlaying) {
        //Play event has not been captured yet
        if(seconds > 0) {
          //Video should be playing
          this.videoPlay();
          console.log('Video Rescued: ' + seconds, this.config.checkCount);
        } else {
          //Check again after a wait
          this.config.checkCount++;
          setTimeout(() => {
            this.videoTimeCheck();
          }, 500);
        }
      }
    });
  }


  //-----------------------------------------------
  // Video Playback started
  //-----------------------------------------------
  videoPlay() {
    //Flags
    this.config.flags.videoLoaded = true;
    this.config.flags.videoPlaying = true;

    //Class
    this.videoWrapper.classList.add('playing');
  }

  
  //-----------------------------------------------
  // Video Pause
  //-----------------------------------------------
  videoPause() {
    //Flag
    this.config.flags.videoPlaying = false;
  }

}